@if (!filtersSelected && !dashboardLayoutLoading) {
<div class="gg-loader" style="width: calc(100% - 94px); height: calc(100% - 155px);"> <div class="gg-loader-text"> <img src="assets/img/arrow-filter-sm.png"></div> </div>
}
@if (dashboardLayoutLoading) {
<div style="text-align: center; padding: 40px;"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
}
@if (filtersSelected && !dashboardLayoutLoading) {
<div class="container-fluid mb-40 dashboard-container" [ngClass]="currentTheme" style="position: relative;">
    @if (isFiltering) {
<div class="filtering-overlay">
        <i class="fa fa-spin fa-spinner fa-2x"></i>
        <span>Updating...</span>
    </div>
}
    @if (dashboardOptions.dashboard_alert_text) {
<div class="row" style="margin: 5px 0px;">
        <div class="col-md-12" style="background-color: #e37902; color: #ffffff; padding: 5px;">
            {{dashboardOptions.dashboard_alert_text}}
        </div>
    </div>
}
    <div class="row">
        @if (!dashboardLoaded || filters.length > 0) {
<div class="data-filters col-12">
            @if (!dashboardLoaded) {
<div class="filter-loader">
                <i class="fa fa-spin fa-spinner" ></i>
            </div>
}
                @for (dashboardFilter of filters; track $index) {
<gtw-df-select-multiple [filter]="dashboardFilter" (filterChange)="filterChange()"></gtw-df-select-multiple>
}
        </div>
}
    </div>
    @if (dashboardLoaded && (!dashboardOptions.components || dashboardOptions.components.length === 0)) {
<div class="dashboard-no-data">
        <i class="fa fa-info-circle"></i>
        <span>No data found.</span>
    </div>
}
    @for (row of dashboardOptions.components; track $index; let i = $index) {
<div class="row dashboard-component-row" [ngClass]="{'mt-10': i > 0}">
        <label class="row-header">{{row[0].row_title}}</label>
        @for (component of row; track $index) {
<div class="col-md-{{component.columns}}">
            @if (component.extraOptions.kpis && component.extraOptions.kpis.length > 0) {
<div class="container-fluid">
                <div class="row kpi-container" style="overflow-x: auto;">
                    @for (kpi of component.extraOptions.kpis; track $index) {
<div>
                        <gtw-ex-component-resolver [options]="kpi" [hideLoader]="true"></gtw-ex-component-resolver>
                    </div>
}
                </div>
            </div>
}
            <gtw-ex-component-container [title]="component.title" [height]="component.height" [actions]="actions" [component]="component">
                <gtw-ex-component-resolver [options]="component"></gtw-ex-component-resolver>
            </gtw-ex-component-container>
        </div>
}
    </div>
}

    <div class="row">
        <div class="gizmo-grid">
            <div class="gg-footer">
                <div class="gg-footer-filters">
                    <div class="filter-icon"><i class="fa fa-filter"></i></div>
                    <div class="gg-filter-container">
                        <div (click)="clearFilters()" class="gg-clear-all"><i class="fa fa-times"></i></div>
                        @for (filter of footerFiltersLists; track $index) {
<div class="filter-item" [title]="filter.tooltip || ''">
                            {{filter.name}}:{{filter.selected.length}}
                            Selected<div class="gg-clear-item" (click)="clearFilter(filter)"><i class="fa fa-times"></i></div>
                        </div>
}

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
}
